import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

interface ResetButtonProps {
  hasDefaultValues: boolean;
  isDisabled?: boolean;
}

export const StyledResetButton = styled(Box)<ResetButtonProps>`
  color: ${({ theme }) => theme.colors.textDisabled};
  &:hover {
    ${({ hasDefaultValues, theme, isDisabled }) => {
      if (!hasDefaultValues && !isDisabled) return { color: theme.colors.buttonPrimary };
      return null;
    }}
  }
`;
